<template>
  <v-layout>
    <!-- PROGRESS BAR -->
    <v-flex 
      class="timeslider" 
      :style="{ width: `${videoPercentage * 100}%`}"
      v-if="!show" />
    <!-- HEADER -->
    <v-layout
      id="headerPOS"
      row
      wrap
      align-start
      @click="$emit('controls-clicked')"
      v-if="show">
      <v-flex xs12>
        <v-layout
          id="headerGrad"
          row
          wrap
          align-center>
          <!-- S P A C E R -->
          <v-flex xs12 class="mt-3" />
          <!-- BACK ARROW -->
          <v-flex xs1 text-xs-center>
            <v-icon @click="$emit('cancel-class')" class="icon-size-1">arrow_back</v-icon>
          </v-flex>
          <v-flex xs10 text-xs-center class="font-title">{{ $store.getters.getCurrentVideo.name }}</v-flex>
          <!-- CLOCK -->
          <v-flex xs1 text-xs-center class="font-number">{{ $store.getters.getCurrentTime }}</v-flex>
          <!-- S P A C E R -->
          <v-flex xs12 class="mt-5" />
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- CONTROLS -->
    <v-layout
      id="controlsPOS"
      row
      wrap
      align-end
      @click="$emit('controls-clicked')"
      v-if="show">
      <v-flex xs12>
        <v-layout
          id="controlsGrad"
          row
          wrap
          align-center>
          <!-- TIME & SEEK -->
          <v-flex xs12 class="font-number">
            <v-layout row wrap align-center>
              <v-flex xs1 text-xs-center>{{ isLive ? "LIVE" : secToMin(currentTime) }}</v-flex>
              <v-flex xs10>
                <v-slider
                  :disabled="isLive"
                  class="sliderAlignSeek"
                  color="white"
                  :max="videoLength"
                  :value="currentTime"
                  @input="$emit('seeking-video', $event)" />
              </v-flex>
              <v-flex xs1 text-xs-center>{{ isLive ? "LIVE" : secToMin(videoLength) }}</v-flex>
            </v-layout>
          </v-flex>
          <!-- BTNS -->
          <v-flex xs12>
            <v-layout row wrap align-center>
              <!-- PLAY/PAUSE -->
              <v-flex xs1 text-xs-center>
                <v-icon :disabled="isLive" @click="$emit('play-clicked')" class="icon-size-1">
                  {{ playButtonIcon }}
                </v-icon>
              </v-flex>
              <!-- VOLUME -->
              <v-flex xs1 text-xs-center>
                <v-icon @click="$emit('mute-clicked')" class="icon-size-1">{{ muteButtonIcon }}</v-icon>
              </v-flex>
              <v-flex xs2 text-xs-center align-center>
                <v-slider
                  class="sliderAlignVol"
                  color="white"
                  :max="100"
                  :value="currentVolume"
                  @input="$emit('seeking-volume', $event)" />
              </v-flex>
              <!-- EMPTY SLOT -->
              <v-flex xs6 />
            </v-layout>
            <!-- S P A C E R -->
            <v-layout>
              <v-flex xs12 class="mt-3" />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean
    },
    currentTime: {
      type: Number,
      default: 0
    },
    videoLength: {
      type: Number,
      default: 0
    },
    currentVolume: {
      type: Number,
      default: 70
    },
    isPlaying: {
      type: Boolean
    },
    isMuted: {
      type: Boolean
    },
    isLive: {
      type: Boolean
    },
  },
  methods: {
    secToMin(sec) {
      const modSec = sec % 60;
      return (sec - (modSec)) / 60 + (modSec > 9 ? ":" : ":0") + parseInt(modSec);
    },
  },
  computed: {
    playButtonIcon() {
      return this.isPlaying ? "pause" : "play_arrow";
    },
    muteButtonIcon() {
      return this.isMuted ? "volume_off" : "volume_up";
    },
    videoPercentage() {
      if (this.videoLength === 0) return 0;
      return this.currentTime / this.videoLength;
    }
  },
};
</script>

<style>
#headerPOS {
  position: absolute !important;
  top: 0px;
  left: 0px;
  z-index: 2 !important;
  width: 100% !important;
  height: 10% !important;
}

#controlsPOS {
  position: absolute !important;
  top: 0px;
  left: 0px;
  z-index: 1 !important;
  width: 100% !important;
  height: 100% !important;
}

#controlsGrad {
  background: linear-gradient(transparent, black) !important;
}

#headerGrad {
  background: linear-gradient(black, transparent) !important;
}

.slider__thumb {
  transform: translateY(-50%) scale(2) !important;
}

.slider__track__container,
.slider__track,
.slider__track-fill {
  height: 10px !important;
}

.sliderAlignSeek {
  margin-left: 8px !important;
}

.sliderAlignVol {
  margin-bottom: 15px !important;
}

.iconDisable {
  color: dimgray !important;
}

.timeslider {
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: white;
  height: 10px;
  z-index: 1
}
</style>


// WEBPACK FOOTER //
// src/components/player/PlayerControls.vue